<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M5.4 14.142a6.732 6.732 0 0 1-2.117-1.425A6.732 6.732 0 0 1 1.858 10.6 6.492 6.492 0 0 1 1.333 8c0-.922.175-1.789.525-2.6a6.732 6.732 0 0 1 1.425-2.117c.6-.6 1.306-1.075 2.117-1.425A6.492 6.492 0 0 1 8 1.333c.922 0 1.789.175 2.6.525.811.35 1.517.825 2.117 1.425.6.6 1.075 1.306 1.425 2.117.35.811.525 1.678.525 2.6 0 .922-.175 1.789-.525 2.6a6.732 6.732 0 0 1-1.425 2.117c-.6.6-1.306 1.075-2.117 1.425a6.492 6.492 0 0 1-2.6.525 6.492 6.492 0 0 1-2.6-.525Zm2.6-.809c.6 0 1.178-.097 1.733-.291a5.301 5.301 0 0 0 1.534-.842L3.8 4.733a5.3 5.3 0 0 0-.842 1.534A5.21 5.21 0 0 0 2.667 8c0 1.489.516 2.75 1.55 3.783C5.25 12.817 6.51 13.333 8 13.333Zm4.2-2.066a5.3 5.3 0 0 0 .842-1.534A5.21 5.21 0 0 0 13.333 8c0-1.489-.516-2.75-1.55-3.783C10.75 3.183 9.49 2.667 8 2.667c-.6 0-1.178.097-1.733.291a5.3 5.3 0 0 0-1.534.842l7.467 7.467Z"
        />
    </svg>
</template>

<script setup lang="ts">
type BlockIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<BlockIconProps>();
</script>
